import React, { useContext } from 'react'
import { 
  Container,
  HeaderDiv,
  HeaderText,
  PdfButtonDiv,
  PdfButtonImg,
  PdfButtonText,
  TextBox,
  TextRow,
  SimpleText
} from './style'
import invoice from '../../../../../assets/certificates/AddCertificate/invoice.svg'
import CertificatesContext from '../../../../../contexts/CertificatesContext'

const CertificateOverview: React.FC = () => {
  const { certificate } = useContext(CertificatesContext)

  return (
      <Container>
        <HeaderDiv>
          <HeaderText>Cliente (Customer): {certificate.customerCompany.companyName} </HeaderText>
          {/* <PdfButtonDiv>
            <PdfButtonImg src={invoice}/>
            <PdfButtonText>Visualizar PDF</PdfButtonText>
          </PdfButtonDiv> */}
        </HeaderDiv>
        <TextBox>
          <TextRow>
            <SimpleText className='left'>N° do certificado: 123456</SimpleText>
            <SimpleText>Data: Hoje</SimpleText>
          </TextRow>
          <TextRow>
            <SimpleText className='left'>Nota fiscal: 004321</SimpleText>
            <SimpleText>N° da corrida: {certificate.heatNumber.heatNumber}</SimpleText>
          </TextRow>
        </TextBox>
        <TextBox>
          <TextRow>
            <SimpleText>Descrição: {certificate.material}</SimpleText>
          </TextRow>
          <TextRow>
            <SimpleText>Tratamento térmico: {certificate.heatTreatment}</SimpleText>
          </TextRow>
        </TextBox>
        <TextBox>
          <TextRow>
            <SimpleText>Material de partida: Quadrado de F55, #200 x 150 x 500</SimpleText>
          </TextRow>
          <TextRow>
            <SimpleText>Usina fabricante: Beall Industry</SimpleText>
          </TextRow>
        </TextBox>
      </Container>
  )
}
export default CertificateOverview
